import EpiApiClient from "@/services/serviceClients/epiApiClient";
import { 
    GET_ELIGIBLE_BRANCHES_API_PATH,
    SHIP_TO_ADDRESS_API_PATH,
    ORDER_CATALOG_ORDER_TEMPLATE_API_PATH,
    ORDER_CATALOG_TAMPLATES_FOR_ORDER_API_PATH,
    SMART_TEMPLATES_MANUFACTURERS_API_PATH,
    SMART_TEMPLATES_CONTRACTOR_API_PATH,
    SYSTEM_INTEGRATION_API_PATH,
    SMART_SUBSTITUTIONS_API_PATH,
    SAVE_DRAFT_ORDER_API_PATH,
    SAVE_NEW_DRAFT_ORDER_API_PATH,
    ADD_ORDER_TEMPLATE_API_PATH,
    CUSTOMER_SUPPLIER_PROMOTIONS_API_PATH,
    AZURE_BLOB_IMAGE_API_PATH,
    AZURE_BLOB_IMAGE_PROXY_API_PATH,
    AZURE_BLOB_UPLOAD_API_PATH,
    AZURE_BLOB_DELETE_API_PATH
 } from "@/config/constants"

class customerService {
    static getEligibleBranches(returnOnlyBranchCodes = false, sortByName = false) {
        return EpiApiClient.get(`${GET_ELIGIBLE_BRANCHES_API_PATH}?returnOnlyBranchCodes=${returnOnlyBranchCodes.toString()}&sortByName=${sortByName.toString()}`)
            .then(response => ({ success: true, data: response.data }))
            .catch(error => ({ success: false, error: error.response.data.error_description }));
    }

    static getShipToAddresses() {
        return EpiApiClient.get(SHIP_TO_ADDRESS_API_PATH)
             .then(response => ({ success: true, data: response.data }))
            .catch(error => ({ success: false, error: error.response.data.error_description }));
    }

    static getTemplates(includeItems, onlyShowFavorites) {
        return EpiApiClient.get(ORDER_CATALOG_ORDER_TEMPLATE_API_PATH,
            {
                params: { includeItems: includeItems, onlyShowFavorites: onlyShowFavorites }
            })
            .then(function (response) {
                return { success: true, data: response.data };
            }).catch(function (error) {
                return {
                    success: false, error: error.response.data.error_description, data: {}
                };
            });
    }

    static getTemplatesData(branchCode = '') {
        return new Promise(function (resolve, reject) {
            EpiApiClient.get(`${ORDER_CATALOG_TAMPLATES_FOR_ORDER_API_PATH}${branchCode}`)
                .then(function (response) {
                    let categories = response.data.Categories;
                    const itemsToMap = categories.reduce(function (acc, curr) {
                        const _items = curr.Templates.reduce(function (a, c) {
                            return Object.assign(a, c.Items.filter(i => i.ItemCode));
                        }, []);
                        return Object.assign(acc, _items);
                    }, []);
                    resolve({
                        itemsToMap,
                        categories,
                        items: response.data.Items || []
                    });
                }).catch(function (error) {
                    if (error.response && error.response.data) {
                        reject(error.response.data.error_description);
                    } else {
                        reject(error);
                    }
                })
        });
    }
    static getSmartSubstitutions(payload) {
        return EpiApiClient.post(SMART_SUBSTITUTIONS_API_PATH, payload)
            .then(function (response) {             
                return { success: true, data: response.data.substitutions };
            }).catch(function (error) {            
                const errorDesc = error.response && error.response.data
                    ? error.response.data.error_description
                    : error.message;
                return {
                    success: false, error: errorDesc, data: null
                };
            });
    }
    
    static getSmartTemplateManufacturers(branchCode, top, language = 'en') {
        return EpiApiClient.get(`${SMART_TEMPLATES_MANUFACTURERS_API_PATH}/${branchCode}/${top}/${language}`)
            .then(function (response) {
                return { success: true, data: response.data.Data };
            }).catch(function (error) {
                return {
                    success: false, error: error.response.data.error_description, data: null
                };
            });
    }

    
    static getSmartTemplateContractors(manufacturer) {
        return EpiApiClient.get(`${SMART_TEMPLATES_CONTRACTOR_API_PATH}${manufacturer}`)
            .then(function (response) {
                return { success: true, data: response.data.Data };
            }).catch(function (error) {
                return {
                    success: false, error: error.response.data.error_description, data: null
                };
            });
    }

    static saveDraftOrder(dto) {
        return EpiApiClient.post(SAVE_DRAFT_ORDER_API_PATH, dto)
            .then(function (response) {
                return { success: true, data: response.data };
            }).catch(function (error) {
                const errorDesc = error?.response?.data?.error_description || error?.message;
                return { success: false, error: errorDesc };
            });
    }

    static saveNewDraftOrder(dto) {
        return EpiApiClient.post(SAVE_NEW_DRAFT_ORDER_API_PATH, dto)
            .then(function (response) {
                return { success: true, data: response.data };
            }).catch(function (error) {
                const errorDesc = error?.response?.data?.error_description || error?.message;
                return { success: false, error: errorDesc };
            });
    }

    static addSystemIntegration(payload) {
        return EpiApiClient.post(`${SYSTEM_INTEGRATION_API_PATH}AddIntegration`, payload)
            .then(function (response) {
                return { success: true, data: response.data };
            }).catch (function (error) {
                return { success: false, error: error?.error_description };
            });
    }

    static getSystemIntegrationHasIntegrationConfigured(payload) {
        return EpiApiClient.post(`${SYSTEM_INTEGRATION_API_PATH}HasIntegrationConfigured`, payload)
            .then(function (response) {
                return { success: true, data: response.data };
            }).catch (error => {
                return { success: false, error: error?.error_description };
            });
    }
    
    static addOrderTemplate(model) {
        return EpiApiClient.post(ADD_ORDER_TEMPLATE_API_PATH,
            model
        )
            .then(function (response) {
                return { success: true, data: response.data };
            }).catch(function (error) {
                return { success: false, error: error.response.data.ModelState };
            });
    }

    static enrollSupplierPromotion(payload) {
        return EpiApiClient.post(CUSTOMER_SUPPLIER_PROMOTIONS_API_PATH,
            payload,
            {
                handleError: false
            })
            .then(function (response) {
                return { success: true, data: response.data };
            }).catch(function (error) {
                return { success: false, error: error.response.data.ModelState };
            });
    }
    static unenrollSupplierPromotion(customerCode, supplierId, payload) {
        const url = `${CUSTOMER_SUPPLIER_PROMOTIONS_API_PATH}/${customerCode}/${supplierId}`;
        return EpiApiClient.put(url, payload)
            .then(function (response) {
                return { success: true, data: response.data };
            }).catch(function (error) {
                return { success: false, error: error.response.data.error_description };
            });
    }

    /**
     * Gets the Azure Blob image URL (returns the blob storage URL with SAS token)
     * Note: This URL may be blocked by CORS/Private Network Access in browsers.
     * Consider using GetAzureBlobImageProxyUrl instead.
     */
    static GetAzureBlobImage(containerName, imageName) {
        return EpiApiClient.get(`${AZURE_BLOB_IMAGE_API_PATH}/${containerName}/${imageName}`)
            .then(function (response) {
                return { success: true, data: response.data };
            }).catch(function (error) {
                return { success: false, error: error.response?.data?.error_description || 'Failed to get image' };
            });
    }

    /**
     * Returns the proxy URL for an Azure Blob image to avoid CORS/Private Network Access issues.
     * Use this URL directly in <img src="..."> tags instead of the blob storage URL.
     * @param {string} containerName - Azure container name (e.g., "customer-logos")
     * @param {string} imageName - Image file name
     * @returns {string} Proxy URL for the image
     */
    static GetAzureBlobImageProxyUrl(containerName, imageName) {
        if (!containerName || !imageName) {
            return '';
        }
        return `${AZURE_BLOB_IMAGE_PROXY_API_PATH}/${encodeURIComponent(containerName)}/${encodeURIComponent(imageName)}`;
    }

    static UploadAzureBlobImage(formData, containerName, imageName) {
        return EpiApiClient.post(
            `${AZURE_BLOB_UPLOAD_API_PATH}/${containerName}/${imageName}`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        )
            .then(function (response) {
                return { success: true, data: response.data };
            })
            .catch(function (error) {
                console.error('UploadAzureBlobImage failed:', error);
                return { success: false, error: error.response?.data?.error_description || 'Upload failed' };
            });
    }

    static DeleteAzureBlobImage(containerName, imageName) {
        return EpiApiClient.delete(`${AZURE_BLOB_DELETE_API_PATH}/${containerName}/${imageName}`)
            .then(function (response) {
                return { success: true, data: response.data };
            })
            .catch(function (error) {
                console.error('DeleteAzureBlobImage failed:', error);
                return { success: false, error: error.response?.data?.error_description || 'Delete failed' };
            });
    }
}

export default customerService;